import { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { useForm } from 'utils/hooks'
import { Flex } from 'components/shared/flex'
import '../preview.scss'
import { Symptom } from '../result_v2'
import { SelectField } from 'components/shared/input'
import axios from 'axios'
import { LiteTestView } from './lite_test_view'
import { LiteTestResultForm } from 'api/result_lite'
import { LitePdfResult } from '@craif/product.pdf-result'
import { LiteSample } from '@craif/product.lite_sample'
import { User } from '@craif/product.entities.user'
import { SYMPTOMS } from '../preview_results'

type Props = {
    history: H.History
}

const TestResultLite = (props: Props) => {
    const testUser: User = {
        id: 0,
        code: 'RL_xxxxxx',
        familyName: '山田',
        familyNameKana: 'ヤマダ',
        givenName: '太郎',
        givenNameKana: 'タロウ',
        email: 'test@craif.com',
        tel: '000-0000-0000',
        birthday: '1980-10-10',
        gender: 'MALE',
        apiTarget: 'remote',
        address: {
            zipCode: '1000000',
            prefecture: '東京都',
            city: '千代田区',
            line: 'テスト町',
            building: 'テストビル',
            whole: '1000000 東京都 千代田区 テスト町 テストビル',
        },
    }
    const [testLiteSample, setTestLiteSample] = useState<LiteSample>()
    const [symptoms, setSymptoms] = useState<Symptom[]>([])
    const form = useForm<LiteTestResultForm>({
        enabled: true,
        inspectionDate: '2024-06-01',
        gender: 'MALE',
        resultValue: 0,
        symptoms: [],
    })
    const formPrev = useForm<LiteTestResultForm>({ inspectionDate: '2024-06-01', gender: 'MALE', enabled: false, resultValue: 0, symptoms: [] })
    const formPrev2 = useForm<LiteTestResultForm>({ inspectionDate: '2024-05-01', gender: 'MALE', enabled: false, resultValue: 0, symptoms: [] })
    const formPrev3 = useForm<LiteTestResultForm>({ inspectionDate: '2024-04-01', gender: 'MALE', enabled: false, resultValue: 0, symptoms: [] })
    const formPrev4 = useForm<LiteTestResultForm>({ inspectionDate: '2024-03-01', gender: 'MALE', enabled: false, resultValue: 0, symptoms: [] })

    useEffect(() => {
        setSymptoms(SYMPTOMS as Symptom[])
    }, [])

    return (
        <>
            <Flex>
                <div className="no-print" style={{ width: 350, fontSize: 12, position: 'sticky', top: 0, zIndex: 100 }}>
                    <div style={{ padding: 10, backgroundColor: 'white', marginTop: 10, height: '95vh', overflow: 'scroll' }}>
                        <SelectField
                            form={form}
                            attr={'gender'}
                            selectItems={[
                                { label: '男性', value: 'MALE' },
                                { label: '女性', value: 'FEMALE' },
                            ]}
                            label="性別"
                        />
                        <LiteTestView
                            form={form}
                            formPrev={formPrev}
                            formPrev2={formPrev2}
                            formPrev3={formPrev3}
                            formPrev4={formPrev4}
                            symptoms={symptoms}
                            setSample={setTestLiteSample}
                        />
                    </div>
                </div>
                <div>{testLiteSample && <LitePdfResult liteSample={testLiteSample as any} />}</div>
            </Flex>
        </>
    )
}

export default withRouter(TestResultLite)
